import axios from '@/plugins/axios'

const getSettings = async ({ userId = null }) => {
  try {
    const params = {}
    if (userId) params.user_id = userId
    const response = await axios.get('settings', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getSetting = async ({ key, userId = null }) => {
  try {
    const params = {}
    if (userId) params.user_id = userId
    const response = await axios.get(`settings/${key}`, {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const toggleDonation = async () => {
  try {
    const response = await axios.post('settings/donation', {
      _method: 'PUT'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const update = async ({ key, value, userId = null }) => {
  try {
    const postData = {
      value: value,
      _method: 'PUT'
    }
    if (userId) postData.user_id = userId
    const response = await axios.post(`settings/${key}`, postData)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const update2fa = async () => {
  try {
    const response = await axios.put('settings/two-factor-authentication')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getSettings,
  getSetting,
  toggleDonation,
  update,
  update2fa
}
